import api from "../axios/index";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

export const getMedicationOptions = async (location_id) => {
  const account_id = getAccountId();
  const response = await api.get(
    `/ccm/${account_id}/${location_id}/medications/`
  );
  return response.data;
};

export const addMedicationOption = async (data, location_id) => {
  const account_id = getAccountId();
  const response = await api.post(
    `/ccm/${account_id}/${location_id}/medications/`,
    data
  );
  return response.data;
};

export const editMedicationOption = async ({ id, data, location_id }) => {
  const account_id = getAccountId();
  const response = await api.patch(
    `/ccm/${account_id}/${location_id}/medications/${id}/`,
    data
  );
  return response.data;
};

export const deleteMedicationOption = async (id, location_id) => {
  const account_id = getAccountId();
  const response = await api.delete(
    `/ccm/${account_id}/${location_id}/medications/${id}/`
  );
  return response.data;
};

export const getDrNoteMedications = async (patient_id, location_id) => {
  const account_id = getAccountId();
  const response = await api.get(
    `/ccm/${account_id}/${location_id}/patients-medications/?patient_id=${patient_id}&from_doctor_note=true`
  );
  return response.data;
};

export const getPatientMedications = async (careplan_id, location_id) => {
  const account_id = getAccountId();
  const response = await api.get(
    `/ccm/${account_id}/${location_id}/patients-medications/?care_plan_id=${careplan_id}`
  );
  return response.data;
};

export const addPatientMedications = async (location_id, data) => {
  const account_id = getAccountId();
  const response = await api.post(
    `/ccm/${account_id}/${location_id}/patients-medications/`, data
  );
  return response.data;
};

export const deletePatientMedications = async (id, location_id) => {
  const account_id = getAccountId();
  const response = await api.delete(
    `/ccm/${account_id}/${location_id}/patients-medications/${id}/`
  );
  return response.data;
};

export const editPatientMedications = async (id, data, location_id) => {
  const account_id = getAccountId();
  const response = await api.patch(
    `/ccm/${account_id}/${location_id}/patients-medications/${id}/`,
    data
  );
  return response.data;
};
